import { isFunction } from "sb-helpers";
/**
 * Map of all the loaded paths.
 * @private
 */
const scripts = {};
/* istanbul ignore next */
export function dynamicScriptLoad(path, res, rej) {
    let paths = Array.isArray(path) ? path : [path];
    let error = isFunction(rej) ? rej : () => { };
    let success = isFunction(res) ? res : () => { };
    let result = undefined;
    /*
    The reason this function is ignored from tests coverage is because it is using browser APIs to
    download and execute scripts that cannot be emulated in NodeJS runtime.

    In order to do tests for it we need to emulate:
    - document
    - - - getElementsByTagName()
    - - - createElement()
    - head element
    - - - insertBefore()
    - script element
    - - - fetch script from URL and parse it as source of the script element
    - - - onload
    - - - onerror
    - - - onreadystatechange
    - - - readyState
    */
    /* istanbul ignore next */
    let promise = Promise.all(paths.map(x => new Promise((resolve, reject) => {
        if (!scripts[x] && x !== "") {
            let head = document.getElementsByTagName("head")[0];
            let el = document.createElement("script"), loaded = 0;
            el.onload = el["onreadystatechange"] = e => {
                if ((el["readyState"] &&
                    !(/^c|loade/.test(el["readyState"]))) ||
                    loaded) {
                    return;
                }
                loaded = 1;
                scripts[x] = true;
                // tslint:disable-next-line
                el.onload = el["onreadystatechange"] = null;
                resolve(x);
            };
            el.onerror = (e) => {
                let src = e && typeof e !== "string" && e.target && e.target["src"];
                if (src) {
                    console.warn(`Failed to download file at: ${src}`);
                }
                else {
                    console.warn(`Failed to download file. Err: ${e}`);
                }
                reject(e);
            };
            el.async = true;
            el.src = x;
            head.insertBefore(el, head.lastChild);
        }
        else {
            resolve(x);
        }
    })));
    /* istanbul ignore next */
    if (typeof res === "undefined" && typeof rej === "undefined") {
        result = promise;
        /* istanbul ignore next */
    }
    else {
        promise
            .then(/* istanbul ignore next */ /* istanbul ignore next */ x => {
            success(x);
            return x;
        })
            .catch(/* istanbul ignore next */ /* istanbul ignore next */ x => {
            error(x, paths);
            return x;
        });
    }
    return result;
}
//# sourceMappingURL=DynamicScriptLoad.js.map